import React, {Component} from 'react';
import Modal from 'react-bootstrap-modal';

import 'sass/modals/modalPaymentOverlay.scss';

import {t} from 'l10n';

class ModalPaymentOverlay extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    render() {
        let {show, closeFn, children} = this.props;

        if (!show) return null;

        return (
            <Modal className="modalPaymentOverlay" show={show} onHide={closeFn}>
                <Modal.Body>
                    {children}
                </Modal.Body>
            </Modal>
        )
    }
}

export default ModalPaymentOverlay;


// WEBPACK FOOTER //
// ./src/components/modals/ModalPaymentOverlay.js